<template>
  <b-card no-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(name)="data">
        <div class="font-weight-bold font-small-3 text-primary">
          {{ data.item.company }}
        </div>
        <div class="font-weight-bold">
          {{ data.item.name }}
        </div>
        <div class="font-small-3 text-muted">
          IP: {{ data.item.ip_address }} - {{ moment(data.item.created).format('DD.MM.YYYY HH:mm') }} tarihinde gönderildi.
        </div>
      </template>
      <template #cell(control)="data">
        <b-button
          variant="primary"
          size="sm"
          :to="$route.path + '/view/' + data.item.id"
        >
          <FeatherIcon icon="EyeIcon" />
          Görüntüle
        </b-button>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BTable, BPagination, BButton, BCardFooter,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'webforms'
export default {
  name: 'Index',
  components: {
    BCard,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'name',
          label: 'AD SOYAD',
        },
        {
          key: 'email',
          label: 'E-POSTA',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'phone',
          label: 'TELEFON',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'webform_department',
          label: 'DEPARTMAN',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.company AS company`,
          `${tableName}.name AS name`,
          `${tableName}.email AS email`,
          `${tableName}.phone AS phone`,
          'webform_departments.title AS webform_department',
          `${tableName}.ip_address AS ip_address`,
          `${tableName}.created AS created`,
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['webforms/dataList']
    },
    dataCounts() {
      return this.$store.getters['webforms/dataCounts']
    },
    saveData() {
      return this.$store.getters['webforms/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('webforms/getDataList', this.dataQuery)
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
